export default __webpack_public_path__ + "static/media/Group2604.ab64552e.png";